import { IconBuildingStore } from "@tabler/icons-react";
import { type ComponentType, createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const PartnersPage = lazy(() => import("./PartnersPage").then((m) => ({ default: m.PartnersPage })));
const PartnerCreatePage = lazy(() => import("./PartnersPage").then((m) => ({ default: m.PartnerCreatePage })));
const PartnerDetailPage = lazy(() => import("./PartnerDetailPage").then((m) => ({ default: m.PartnerDetailPage })));

const el = (c: ComponentType) => createElement(Suspense, { fallback: null }, createElement(c));

export const routes: FeatureRoute[] = [
  { path: "/admin/partners", roles: CAPS.admin.partnersRead, element: el(PartnersPage) },
  { path: "/admin/partners/new", roles: CAPS.admin.partnersWrite, element: el(PartnerCreatePage) },
  { path: "/admin/partners/:id", roles: CAPS.admin.partnersRead, element: el(PartnerDetailPage) },
];

export const nav: NavItem[] = [
  {
    label: "Partners",
    path: "/admin/partners",
    icon: IconBuildingStore,
    surface: "admin",
    roles: CAPS.admin.partnersRead,
  },
];
